import {
  BodyText,
  Flex,
  HeadlineTitle,
  ParagraphTitle,
  theme,
} from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled, { css } from 'styled-components';
import { InfoCardType } from './InfoCardType';

export interface StyledInfoCardProps {
  cardType: InfoCardType;
  backgroundColor?: string;
  backgroundImage?: string;
}

export const getBackgroundImageStyle = (
  cardType: InfoCardType,
  backgroundImage: string,
) => {
  if (cardType === InfoCardType.CardSmallVisual)
    return css`
      background-image: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.6),
          rgba(0, 0, 0, 0.6)
        ),
        url(${backgroundImage});
    `;

  if (cardType === InfoCardType.CardWideVisual) {
    return css`
      background-image: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.0001) 0.64%,
          rgba(0, 0, 0, 0.75) 100%
        ),
        url(${backgroundImage});
    `;
  }

  return '';
};

export const CardWrapper = styled(Flex)<StyledInfoCardProps>`
  padding: 1.25rem;
  padding-right: 1.75rem;
  flex-direction: row;

  width: 100%;
  ${(props) =>
    props.cardType === InfoCardType.CardSmallPlain ||
    props.cardType === InfoCardType.CardSmallVisual
      ? 'max-width: 23rem;'
      : ''};

  border-radius: 0.3rem;
  border: ${(props) =>
    props.cardType === InfoCardType.CardSmallPlain ||
    props.cardType === InfoCardType.CardWidePlain
      ? `2px solid ${theme.colors.primaryK10}`
      : '0'};

  ${(props) =>
    props.cardType === InfoCardType.CardWidePlainTeal
      ? `background-color: ${theme.colors.primaryT2};
      ${ParagraphTitle}, ${StyledHeadlineTitle}, ${BodyText} { color: ${theme.colors.primaryW}; }`
      : ''};

  ${(props) =>
    props.backgroundColor ? `background-color: ${props.backgroundColor};` : ''}
  ${(props) =>
    props.backgroundImage
      ? css`
          ${getBackgroundImageStyle(props.cardType, props.backgroundImage)}
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        `
      : ''};
`;

export const CardIcon = styled(Flex)<{ color: string }>`
  height: 1.25rem;
  width: 1.25rem;
  margin: 0.04rem 1rem 0 0;

  ${(props) =>
    props.color
      ? `svg,
    svg g {
      fill: ${props.color};
    }`
      : ''};
`;

export const CardContent = styled(Flex)<StyledInfoCardProps>`
  width: 100%;

  ${mediaQuery('md')} {
    ${(props) =>
      props.cardType === InfoCardType.CardWidePlain ||
      props.cardType === InfoCardType.CardWidePlainTeal
        ? css`
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          `
        : ''}
  }
`;

export const StyledParagraphTitle = styled(ParagraphTitle)`
  margin-bottom: 0.9rem;
`;

export const StyledHeadlineTitle = styled(HeadlineTitle)<StyledInfoCardProps>`
  margin-bottom: 0.9rem;
  color: ${theme.colors.primaryW};

  ${(props) =>
    props.cardType === InfoCardType.CardWideVisual
      ? 'padding-top: 14.563rem;'
      : ''};
`;

export const CardDescription = styled(BodyText)<StyledInfoCardProps>`
  margin-bottom: 0;

  ${(props) =>
    props.cardType === InfoCardType.CardSmallVisual ||
    props.cardType === InfoCardType.CardWideVisual
      ? `color: ${theme.colors.primaryW};`
      : ''};
`;

export const ButtonWrapper = styled(Flex)<StyledInfoCardProps>`
  margin-top: 0.6rem;

  ${mediaQuery('md')} {
    ${(props) =>
      props.cardType === InfoCardType.CardWidePlain ||
      props.cardType === InfoCardType.CardWidePlainTeal
        ? 'margin-top: 0;'
        : ''};
  }
`;
